import React, { useState, useEffect } from 'react';
import { Button } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { postRequest } from '../../../../../../core/apiRequests';
import { notificationSuccess } from '../../../../../../core/actions';
import '../../../clientV2.css';

const ReminderButtonHeader = props => {
  const [checkCustomReminder, setCheckCustomReminder] = useState(false);

  useEffect(() => {
    if (props.selectedAction.length === 1) {
      const [action] = props.selectedAction;
      if (
        !action.life_event_id &&
        !action.tag_action_config_id &&
        !action.sales_opp_id &&
        !action.custom_event_type_id &&
        !action.sales_action_config_id
      ) {
        setCheckCustomReminder(true);
      }
    } else {
      setCheckCustomReminder(false);
    }
  }, [props.selectedAction]);

  const saveSelected = () => {
    const selected = props.selectedAction;
    const reqObj = {
      params: ['today', props.auth.merchantId, 'save'],
      data: { selected },
      query: {
        storeId: props.auth.storeId,
        associateId: props.auth.userId,
        createdBy: `${props.auth.firstName || ''} ${props.auth.lastName || ''}`,
      },
    };
    (async () => {
      const data = await postRequest(reqObj);
      if (data) {
        props.setSelectedAction([]);
        props.setReload(prev => !prev);
        notificationSuccess('Reminder(s) Complete!');
      }
    })();
  };

  return (
    <div className="cb-link-btn-group cb-link-btn-group--wide">
      {checkCustomReminder && (
        <Button
          type="link"
          className="cb-link-btn-action"
          onClick={() => props.setEditReminderModal(true)}
        >
          <FontAwesomeIcon icon={['far', 'pencil']} />
          Edit
        </Button>
      )}
      <Button
        type="link"
        className="cb-link-btn-action"
        onClick={() => props.setAssignPopup(true)}
      >
        <FontAwesomeIcon icon={['far', 'user']} />
        Assign Associate
      </Button>
      <Button
        type="link"
        className="cb-link-btn-action cb-link-btn-action--icon-lg"
        onClick={saveSelected}
      >
        <FontAwesomeIcon icon={['far', 'check-circle']} />
        Complete
      </Button>
      <Button
        type="link"
        className="cb-link-btn-action cb-link-btn-action--icon-lg"
        onClick={() => props.handleClickDismissReminders(true)}
      >
        <FontAwesomeIcon icon={['far', 'eraser']} />
        Dismiss
      </Button>
      <Button
        type="link"
        className="cb-link-btn-action cb-link-btn-action--icon-lg"
        onClick={() => props.setShowSnoozeModal(true)}
      >
        <FontAwesomeIcon icon="fa-sharp fa-regular fa-alarm-clock" />
        Snooze
      </Button>
    </div>
  );
};

export default ReminderButtonHeader;
